import { render, staticRenderFns } from "./Famille.vue?vue&type=template&id=0b9a1582&"
import script from "./Famille.vue?vue&type=script&lang=js&"
export * from "./Famille.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports